<template>
  <div class="ai-drawer-layout">
    <!-- Header -->
    <div class="ai-drawer-header">
      <span class="ai-drawer-header-back">
        <img src="~@/common/img/ai.png" class="ai-drawer-header-avatar">
      </span>
      <span class="ai-drawer-header-title">海小昇</span>
      <div class="ai-drawer-header-actions">
        <span class="header-action-btn" @click="$emit('close')">
          <i class="icon-close"></i>
        </span>
      </div>
    </div>

    <!-- Body -->
    <div class="ai-drawer-body">
      <!-- Left Sidebar -->
      <div class="ai-drawer-sidebar" :class="{ unfold: sidebarUnfolded }">
        <div class="sidebar-top">
          <div
            v-for="(item, i) in sidebarItems"
            :key="i"
            class="sidebar-item"
            :class="{ active: activeSidebar === i, 'sidebar-item-history': item.isHistory }"
            @click="onSidebarClick(i)"
            :title="item.tip"
          >
            <i :class="item.icon + ' sidebar-icon'"></i>
            <span class="sidebar-text">{{ item.label }}</span>
          </div>
        </div>
        <div class="sidebar-bottom">
          <div class="sidebar-item center sidebar-fold" @click="sidebarUnfolded = !sidebarUnfolded">
            <i :class="sidebarUnfolded ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></i>
            <span class="sidebar-text">{{ sidebarUnfolded ? '收起' : '展开' }}</span>
          </div>
        </div>
      </div>
      <!-- Main Content -->
      <div class="ai-drawer-main">
        <!-- Home view -->
        <div class="ai-drawer-home" v-if="mainMode === 'home'">
          <div class="home-content">
            <div class="home-greeting">
              你好呀，<span class="home-username" :title="username">{{ username }}</span>
            </div>
            <div class="home-greeting-wave">
              <canvas ref="greetingCanvas" width="228" height="26"></canvas>
            </div>
            <div class="home-intro">
              我是您的智能小助手海小昇，我可以帮您找到平台的资源、功能的使用方法，以及进行课程问答、习题答疑、教学设计，欢迎向我提问~
            </div>
            <div class="home-questions">
              <div class="home-questions-header">
                <span>您可以这样问我：</span>
                <span class="home-questions-refresh" @click="refreshQuestions">换一换</span>
              </div>
              <div class="home-question-list">
                <div
                  v-for="(item, i) in currentQuestions"
                  :key="i"
                  class="home-question-item"
                  @click="askQuestion(item)"
                >
                  <div class="home-question-type">
                    <span>{{ item.type }}</span>
                  </div>
                  <div class="home-question-text">{{ item.text }}</div>
                  <div class="home-question-arrow"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 底部角色 -->
          <div class="home-character">
            <div class="home-character-dec"></div>
            <img src="~@/common/img/ai.png" class="home-character-img">
          </div>
          <div class="home-character-overlay"></div>
        </div>

        <!-- Chat view -->
        <div class="ai-drawer-chat-view" v-else-if="mainMode === 'chat'">
          <div class="chat-messages" ref="chatBox">
            <div class="chat-empty" v-if="historyList.length==0">
              <img src="~@/common/img/ai.png">
              <div>你好！我是海小昇<br>有什么可以帮你的？</div>
            </div>
            <div class="chat-item" v-for="(item,i) in historyList" :key="i">
              <div class="msg-user" v-if="item.genre==1">
                <div class="msg-bubble user-bubble">{{ item.content }}</div>
                <div class="msg-avatar">
                  <img :src="fileUrl+userLogoUrl" :onerror="defaultLogoUrl">
                </div>
              </div>
              <div class="msg-ai" v-else>
                <div class="msg-avatar">
                  <img src="~@/common/img/ai.png">
                </div>
                <div class="msg-body">
                  <div class="msg-bubble think-bubble" v-if="item.reasoning_content" v-html="markdownToHtml(item.reasoning_content)"></div>
                  <div class="msg-bubble ai-bubble" :class="{ 'blinking-dots': item.content=='解答需要时间，请稍等... ...' }" v-html="markdownToHtml(item.content)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- History view -->
        <div class="ai-drawer-history" v-else-if="mainMode === 'history'">
          <div class="history-header">
            历史对话
          </div>
          <div class="history-list" v-if="chatHistoryRaw.length > 0">
            <div
              v-for="item in chatHistoryRaw"
              :key="item.id"
              class="history-item"
              @click="loadHistoryChat(item)"
            >
              <i class="el-icon-chat-dot-round history-item-icon"></i>
              <span class="history-item-title">{{ item.content || '新的对话' }}</span>
            </div>
          </div>
          <div class="history-empty" v-else>
            <span>暂无历史对话</span>
          </div>
        </div>

        <!-- 工具栏（永久显示）：模型切换 + 智能体/课程选择 -->
        <div class="chat-toolbar">
          <el-select size="mini" style="width:150px;" v-model="modelId" placeholder="模型">
            <el-option v-for="item in modelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span ref="plusBtn" class="plus-btn" :class="{active: showAttachPanel}" @click="toggleAttachPanel">
            <i class="el-icon-plus"></i>
          </span>
          <!-- 智能体 / 课程选择弹层 -->
          <transition name="el-fade-in-linear">
            <div class="attach-panel" v-if="showAttachPanel" ref="attachPanel" @click.stop>
              <div class="panel-main">
                <div class="panel-main-item" :class="{active: panelMain==='menu'}" @click="panelMain='menu'">
                  <i class="el-icon-cpu panel-main-icon"></i>
                  <span class="panel-main-text">智能体</span>
                  <i class="el-icon-arrow-right panel-main-arrow"></i>
                </div>
                <div class="panel-main-item" :class="{active: panelMain==='course'}" @click="onCourseMainClick">
                  <i class="el-icon-tickets panel-main-icon"></i>
                  <span class="panel-main-text">课程标题</span>
                  <i class="el-icon-arrow-right panel-main-arrow"></i>
                </div>
              </div>
              <div class="panel-sub">
                <template v-if="panelMain==='menu'">
                  <div class="sub-list">
                    <div class="sub-item" v-for="(m,i) in menuList" :key="m.id" :class="{active: m.id==menuId}" @click="selectMenu(m)">
                      <img :src="getMenuLogo(i)" class="sub-item-icon sub-item-logo">
                      <span class="sub-item-text" :title="m.name">{{ m.name }}</span>
                      <i v-if="m.id==menuId" class="el-icon-check sub-item-check"></i>
                    </div>
                  </div>
                </template>
                <template v-else-if="panelMain==='course'">
                  <el-input size="mini" v-model.trim="courseKeyword" placeholder="输入关键词搜索" clearable @input="onCourseKeywordInput" class="course-search"></el-input>
                  <div class="sub-list">
                    <div class="sub-item" v-for="c in courseList" :key="c.bu_id" :class="{active: c.bu_id==courseItem.bu_id}" @click="selectCourse(c)">
                      <i class="el-icon-tickets sub-item-icon"></i>
                      <span class="sub-item-text" :title="c.lesson_name">{{ c.lesson_name }}</span>
                      <i v-if="c.bu_id==courseItem.bu_id" class="el-icon-check sub-item-check"></i>
                    </div>
                    <div v-if="courseList.length===0" class="sub-empty">暂无课堂</div>
                  </div>
                  <el-pagination small layout="prev, pager, next" :current-page="courseCurrentPage" :page-size="coursePageSize" :total="courseTotal" :pager-count="5" @current-change="handleCourseCurrentChange" v-show="courseTotal>0" class="course-pager"></el-pagination>
                </template>
              </div>
            </div>
          </transition>
        </div>

        <!-- Input box -->
        <div class="ai-drawer-input">
          <div class="input-box">
            <div class="input-area-wrapper" @click="focusInput">
              <div
                ref="inputArea"
                class="input-area"
                contenteditable="true"
                @input="onInput"
                @keydown.enter.exact.prevent="sendMessage"
              >
                <br v-if="!inputText">
              </div>
              <div class="input-placeholder" v-if="!inputText" @click="focusInput">
                您有什么想知道的，来问问我吧。
              </div>
            </div>
            <div class="input-footer">
              <div class="input-footer-left">
                <!-- @ 标签，显示在底部输入框左下角 -->
                <div class="input-tags" v-if="selectedMenuName || (courseItem && courseItem.bu_id)" @click.stop>
                  <span v-if="selectedMenuName" class="input-tag">
                    @{{ selectedMenuName }}<i class="el-icon-close input-tag-close" @click="removeMenuTag"></i>
                  </span>
                  <span v-if="courseItem && courseItem.bu_id" class="input-tag">
                    @{{ courseItem.lesson_name }}<i class="el-icon-close input-tag-close" @click="removeCourseTag"></i>
                  </span>
                </div>
                <!-- <span class="input-counter">{{ inputLength }}/500</span> -->
              </div>
              <div class="input-actions">
                <el-button
                  v-if="!isAnswer"
                  type="primary"
                  size="mini"
                  circle
                  :disabled="inputLength === 0"
                  @click="sendMessage"
                  class="send-btn"
                >
                  <i class="el-icon-right"></i>
                </el-button>
                <el-button
                  v-else
                  type="danger"
                  size="mini"
                  circle
                  @click="cancelQuestion"
                  class="send-btn stop-btn"
                >
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </div>
          </div>
          <div class="ai-drawer-disclaimer">
            <span class="disclaimer-line"></span>
            <span class="disclaimer-text">内容由AI大模型生成，仅供您参考</span>
            <span class="disclaimer-line"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage } from "@/common/js/localstorage";
import aiAssistantApi from "@/api/ai_assistant";
import evaluateClassApi from "@/api/evaluate_class";
import moment from 'moment';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt();

export default {
  name: "AiDrawer",
  data() {
    return {
      // 布局
      sidebarUnfolded: false,
      activeSidebar: 0,
      mainMode: 'home', // 'home' | 'chat' | 'history'
      // 输入
      inputText: "",
      inputLength: 0,
      username: (getStorage("user") && getStorage("user").name) || "用户",
      // 侧栏
      sidebarItems: [
        { label: "新建对话", icon: "el-icon-edit-outline", tip: "新建对话", isHistory: false },
        { label: "历史对话", icon: "el-icon-time", tip: "历史对话", isHistory: true },
      ],
      // 推荐问题
      questionPool: [
        [
          { type: "找功能", iconType: 1, text: "我在哪里可以观看直播？" },
          { type: "找资源", iconType: 2, text: "有没有数学相关的资源？" },
          { type: "教学助手", iconType: 3, text: "帮我生成一个一次函数的教学大纲。" },
          { type: "知识问答", iconType: 4, text: "一次函数和正比例函数有什么区别？" },
          { type: "习题答疑", iconType: 5, text: "已知一个圆的半径为 12cm, 某一弧所对的圆心角为 150°, 该弧的长度是多少？" },
        ],
        [
          { type: "找功能", iconType: 1, text: "怎么参与线上课程？" },
          { type: "找资源", iconType: 2, text: "有没有语文相关的资源？" },
          { type: "教学助手", iconType: 3, text: "帮我设计一个勾股定理的思维导图。" },
          { type: "知识问答", iconType: 4, text: "如何理解勾股定理的几何意义？" },
          { type: "习题答疑", iconType: 5, text: "求解不等式：|2x-3|>5, 写出解集。" },
        ],
      ],
      questionPoolIndex: 0,
      // 对话（从 AiAssistant 迁移）
      fileUrl: window.staticsHost,
      userLogoUrl: (getStorage("user") && (getStorage("user").image_path || getStorage("user").image_url)) || "",
      defaultLogoUrl: "this.src='" + require("@/common/img/default2.png") + "'",
      chatId: 0,
      historyList: [],
      isAnswer: false,
      abortController: null,
      // 历史记录
      chatHistoryRaw: [],       // getUserQuestionPage 原始数据
      menuId: 1,
      pickedMenuId: 0, // 用户显式选择的智能体 id，0=未选择（不显示@标签）
      menuList: [
        { id: 1, name: "通用模型" },
        { id: 2, name: "教学设计" },
        { id: 3, name: "教学分析" },
        { id: 4, name: "教学评价" },
        { id: 5, name: "PPT制作" },
      ],
      // 模型选择（未来扩展，先 Mock）
      modelId: 1,
      modelList: [
        { id: 1, name: "Deepseek-V4-Pro" },
      ],
      // 智能体 / 课程选择弹层
      showAttachPanel: false,
      panelMain: 'menu', // 'menu' | 'course'
      courseKeyword: "",
      courseSearchTimer: null,
      courseList: [],
      courseTotal: 0,
      courseCurrentPage: 1,
      coursePageSize: 10,
      courseItem: {},
    };
  },
  computed: {
    currentQuestions() {
      return this.questionPool[this.questionPoolIndex] || this.questionPool[0];
    },
    selectedMenuName() {
      const m = this.menuList.find(x => x.id === this.pickedMenuId);
      return m ? m.name : "";
    },
  },
  watch: {
    menuId() {
      this.chatId = 0;
      this.historyList = [];
    },
    courseItem() {
      this.chatId = 0;
      this.historyList = [];
    },
    modelId() {
      this.chatId = 0;
      this.historyList = [];
    },
    historyList() {
      this.$nextTick(() => {
        const box = this.$refs.chatBox;
        if (box) box.scrollTop = box.scrollHeight;
      });
    },
    mainMode(val) {
      if (val === 'home') {
        this.$nextTick(() => this.drawGreetingWave());
      }
    },
  },
  mounted() {
    this.drawGreetingWave();
    this.getUserQuestionPage();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    if (this.courseSearchTimer) clearTimeout(this.courseSearchTimer);
  },
  methods: {
    // ===== 原有方法 =====
    drawGreetingWave() {
      const canvas = this.$refs.greetingCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      canvas.width = 228;
      canvas.height = 26;
      ctx.clearRect(0, 0, 228, 26);
      ctx.strokeStyle = "#358BFC";
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctx.beginPath();
      for (let x = 10; x < 100; x += 8) {
        const y = 13 + Math.sin(x * 0.5) * 3 + Math.sin(x * 0.2 + Date.now() * 0.005) * 4;
        if (x === 10) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();
      ctx.font = "18px Arial";
      ctx.fillText("👋", 105, 22);
      requestAnimationFrame(() => this.drawGreetingWave());
    },
    focusInput() {
      this.$refs.inputArea && this.$refs.inputArea.focus();
    },
    onInput(e) {
      this.inputText = e.target.innerText.trim();
      this.inputLength = Math.min(e.target.innerText.length, 500);
    },
    askQuestion(item) {
      const area = this.$refs.inputArea;
      if (area) {
        area.innerText = item.text;
        area.focus();
        const range = document.createRange();
        range.selectNodeContents(area);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
      this.inputText = item.text;
      this.inputLength = item.text.length;
    },
    refreshQuestions() {
      this.questionPoolIndex = (this.questionPoolIndex + 1) % this.questionPool.length;
    },
    // ===== 对话方法（从 AiAssistant 迁移） =====
    markdownToHtml(item) {
      return md.render(item);
    },
    sendMessage() {
      if (this.isAnswer) return; // AI 回复中禁止任何操作
      if (!this.inputText) {
        this.$message.warning("请输入内容");
      } else {
        if (this.mainMode !== 'chat') this.switchToChat();
        this.$nextTick(() => this.submitQuestion());
      }
    },
    createChat() {
      this.menuId = 1; // 新建对话重置为默认智能体（通用模型）
      this.pickedMenuId = 0; // 未显式选择，不显示@标签
      this.chatId = 0;
      this.historyList = [];
      this.inputText = "";
      this.inputLength = 0;
      this.mainMode = 'home';
      if (this.$refs.inputArea) this.$refs.inputArea.innerText = "";
    },
    getUserQuestionPage() {
      aiAssistantApi.getUserQuestionPage({ page: 1, page_size: 5 }).then((response) => {
        if (response.data.status === 0) {
          const list = response.data.data.list || [];
          if (list.length > 0) {
            // 自动恢复最近会话的历史，但保持默认智能体（通用模型）
            this.chatId = list[0].id;
            this.getHistoryList();
          }
        }
      }).catch(() => {});
    },
    getHistoryList() {
      aiAssistantApi.getHistoryList({ chat_id: this.chatId }).then((response) => {
        if (response.data.status === 0) {
          this.historyList = response.data.data.list || [];
        }
      }).catch(() => {});
    },
    submitQuestion() {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      this.isAnswer = true;
      const questionText = this.inputText;
      this.historyList.push({
        id: new Date(),
        genre: 1,
        reasoning_content: "",
        content: questionText,
        create_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      });
      this.historyList.push({
        id: new Date(),
        genre: 2,
        reasoning_content: "",
        content: "解答需要时间，请稍等... ...",
        create_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      });
      this.inputText = "";
      this.inputLength = 0;
      if (this.$refs.inputArea) this.$refs.inputArea.innerText = "";
      const that = this;
      fetchEventSource(window.baseUrl + "/ai_class/ai_assistant/submit_question", {
        signal: this.abortController.signal,
        method: 'POST',
        openWhenHidden: true,
        headers: {
          "Content-Type": 'application/json',
          Accept: 'text/event-stream',
          Authorization: "Bearer " + getStorage("user").token
        },
        body: JSON.stringify({
          content: questionText,
          bu_id: this.courseItem.bu_id || 0,
          genre: this.menuId,
          chat_id: this.chatId,
        }),
        onmessage(event) {
          if (event.data == "[DONE]") {
            that.isAnswer = false;
          } else {
            const msg = JSON.parse(event.data);
            const last = that.historyList[that.historyList.length - 1];
            that.historyList[that.historyList.length - 2].id = parseInt(msg.question_id);
            last.id = parseInt(msg.answer_id);
            if (last.content == "解答需要时间，请稍等... ...") {
              last.content = "";
            }
            if (msg.ReasoningContent) {
              last.reasoning_content = (last.reasoning_content || "") + msg.ReasoningContent;
            } else {
              last.content += msg.Content;
            }
            that.chatId = parseInt(msg.chat_id);
            that.$forceUpdate();
            that.$nextTick(() => {
              const box = that.$refs.chatBox;
              if (box) box.scrollTop = box.scrollHeight;
            });
          }
        },
        onclose() {
          console.log("SSE closed");
        },
        onerror(err) {
          console.error("SSE error:", err);
        },
      });
    },
    // ===== 智能体 / 课程选择 =====
    // 智能体 LOGO：与 ai_assistant/home.vue 的索引映射一致
    getMenuLogo(index) {
      const imgs = [
        require("@/common/img/menu1.png"),
        require("@/common/img/menu3.png"),
        require("@/common/img/menu4.png"),
        require("@/common/img/menu5.png"),
        require("@/common/img/menu2.png"),
      ];
      return imgs[index % imgs.length] || imgs[0];
    },
    toggleAttachPanel() {
      this.showAttachPanel = !this.showAttachPanel;
      if (this.showAttachPanel) {
        this.panelMain = "menu";
      }
    },
    handleClickOutside(e) {
      const panel = this.$refs.attachPanel;
      const plus = this.$refs.plusBtn;
      if (this.showAttachPanel && panel && !panel.contains(e.target) && plus && !plus.contains(e.target)) {
        this.showAttachPanel = false;
      }
    },
    selectMenu(m) {
      this.menuId = m.id;
      this.pickedMenuId = m.id;
      this.showAttachPanel = false;
    },
    selectCourse(c) {
      this.courseItem = c;
      this.showAttachPanel = false;
    },
    removeMenuTag() {
      this.menuId = 1;
      this.pickedMenuId = 0;
    },
    removeCourseTag() {
      this.courseItem = {};
    },
    onCourseMainClick() {
      this.panelMain = "course";
      if (this.courseList.length === 0) {
        this.handleCourseCurrentChange(1);
      }
    },
    handleCourseCurrentChange(val) {
      this.courseCurrentPage = val;
      this.getTeacherLessonPage();
    },
    // 课程关键词即时搜索（300ms 防抖）
    onCourseKeywordInput() {
      if (this.courseSearchTimer) clearTimeout(this.courseSearchTimer);
      this.courseSearchTimer = setTimeout(() => {
        this.handleCourseCurrentChange(1);
      }, 300);
    },
    getTeacherLessonPage() {
      const params = {
        keyword: this.courseKeyword,
        page: this.courseCurrentPage,
        page_size: this.coursePageSize,
      };
      evaluateClassApi.getTeacherLessonPage(params).then((response) => {
        if (response.data.status === 0) {
          this.courseTotal = response.data.data.total || 0;
          this.courseList = response.data.data.list || [];
          this.courseList.forEach(item => { item.check = false; });
        } else {
          this.$message({
            type: "error",
            message: response.data.info.message,
          });
        }
      }).catch(() => { });
    },
    // ===== 侧栏 & 模式切换 =====
    onSidebarClick(i) {
      this.activeSidebar = i;
      if (i === 0) {
        this.createChat();
      } else if (i === 1) {
        this.openHistory();
      }
    },
    switchToChat() {
      this.mainMode = 'chat';
    },
    openHistory() {
      this.mainMode = 'history';
      aiAssistantApi.getUserQuestionPage({ page: 1, page_size: 50 }).then((response) => {
        if (response.data.status === 0) {
          this.chatHistoryRaw = response.data.data.list || [];
        }
      }).catch(() => {});
    },
    loadHistoryChat(item) {
      this.resumeChat(item, true);
    },
    // 恢复会话：沿用该会话的智能体(genre)，$nextTick 确保在 watch menuId 清空 chatId 之后重新赋值
    resumeChat(item, switchView) {
      if (item.genre && item.genre !== this.menuId) {
        this.menuId = item.genre;
      }
      if (item.genre) this.pickedMenuId = item.genre;
      this.$nextTick(() => {
        this.chatId = item.id;
        if (switchView) this.mainMode = 'chat';
        this.getHistoryList();
      });
    },
    cancelQuestion() {
      if (this.abortController) {
        this.abortController.abort();
        this.isAnswer = false;
      }
    },
  },
};
</script>

<style scoped>
/* ======= Layout ======= */
.ai-drawer-layout {
  height: 100%;
  display: flex;
  flex-flow: column;
  position: relative;
  background: #F5F7FB;
}

/* ======= Header ======= */
.ai-drawer-header {
  display: flex;
  align-items: center;
  padding: 8px 16px 8px 8px;
  height: 50px;
  flex-shrink: 0;
  z-index: 1;
}
.ai-drawer-header-back {
  display: inline-block;
  margin-right: 4px;
}
.ai-drawer-header-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.ai-drawer-header-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #333;
  text-align: left;
  padding-left: 10px;
}
.ai-drawer-header-actions {
  display: flex;
  align-items: center;
  gap: 0;
}
.header-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.header-action-divider {
  display: block;
  height: 20px;
  margin-right: 16px;
  border-right: 1px solid rgba(0,0,0,0.08);
}
.icon-close {
  width: 20px;
  height: 20px;
  background: #666;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 10.445L17.445 5 19 6.555 13.555 12 19 17.445 17.445 19 12 13.555 6.555 19 5 17.445 10.445 12 5 6.555 6.555 5 12 10.445z' fill='black'/%3E%3C/svg%3E") no-repeat center;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 10.445L17.445 5 19 6.555 13.555 12 19 17.445 17.445 19 12 13.555 6.555 19 5 17.445 10.445 12 5 6.555 6.555 5 12 10.445z' fill='black'/%3E%3C/svg%3E") no-repeat center;
}
.header-action-btn:hover .icon-close {
  background: #1E62EC;
}

/* ======= Body ======= */
.ai-drawer-body {
  display: flex;
  flex: 1;
  height: 50%;
}

/* ======= Sidebar ======= */
.ai-drawer-sidebar {
  overflow-y: auto;
  flex-shrink: 0;
  padding: 24px 10px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 52px;
  box-sizing: border-box;
  transition: width 0.3s ease;
}
.ai-drawer-sidebar.unfold {
  width: 190px;
}
.sidebar-top {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.sidebar-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  flex-wrap: nowrap;
  white-space: nowrap;
  cursor: pointer;
  z-index: 3;
  position: relative;
  padding-left: 5px;
}
.sidebar-item.center {
  justify-content: center;
}
.sidebar-item-history {
  margin-top: 5px;
  border-top: 1px solid rgba(0,0,0,0.06);
  padding-top: 10px;
}
.sidebar-bottom {
  padding-top: 8px;
}
.ai-drawer-sidebar:not(.unfold) .sidebar-item:nth-child(2) {
  margin-bottom: 16px;
}
.sidebar-icon {
  font-size: 22px;
  color: #6B7B8D;
  flex-shrink: 0;
}
.sidebar-item.active .sidebar-icon,
.sidebar-item:hover .sidebar-icon {
  color: #3A78F6;
}
.sidebar-fold {
  font-size: 14px;
  color: #999;
}
.sidebar-fold:hover {
  color: #1E62EC;
}

.sidebar-text {
  display: none;
  font-size: 14px;
  line-height: 22px;
  color: #666;
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ai-drawer-sidebar.unfold .sidebar-text {
  display: block;
}
.ai-drawer-sidebar.unfold .sidebar-item:first-child .sidebar-text {
  color: #1E62EC;
}
.ai-drawer-sidebar.unfold .sidebar-item.active,
.ai-drawer-sidebar.unfold .sidebar-item:hover {
  border-radius: 4px;
  background: rgba(255,255,255,0.8);
}
.ai-drawer-sidebar.unfold .sidebar-item.active .sidebar-text,
.ai-drawer-sidebar.unfold .sidebar-item:hover .sidebar-text {
  color: #1E62EC;
}
.ai-drawer-sidebar.unfold .sidebar-fold:hover {
  background: none;
}

/* ======= Main ======= */
.ai-drawer-main {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px 0 0 0;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}
/* ======= Home ======= */
.ai-drawer-home {
  flex: 1;
  padding: 24px 24px 0;
  position: relative;
  overflow: hidden auto;
  background: #fff;
  max-height: 655px;
  overscroll-behavior: contain;
}

.home-content {
  position: relative;
  z-index: 2;
  padding: 16px 16px 50px;
}

.home-greeting {
  font-family: "PingFang SC";
  font-weight: 600;
  font-size: 30px;
  height: 42px;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
  text-align: left;
}
.home-username {
  font-weight: 600;
}

.home-greeting-wave {
  width: 228px;
  height: 26px;
  margin-top: 4px;
  overflow: hidden;
}
.home-greeting-wave canvas {
  width: 100%;
  height: 100%;
}

.home-intro {
  font-family: "PingFang SC";
  font-size: 14px;
  line-height: 22px;
  color: #555;
  padding: 8px 0;
  margin-top: 8px;
  text-align: left;
}

.home-questions {
  margin-top: 24px;
}

.home-questions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #666;
}

.home-questions-refresh {
  cursor: pointer;
  color: #999;
  padding-left: 18px;
  position: relative;
}
.home-questions-refresh::before {
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  left: 0;
  top: 2px;
  background: url("data:image/svg+xml,%3Csvg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 8H3.2a4.8 4.8 0 0 0 8.124 3.463l.598 1.077a6 6 0 0 1-8.836-7.984L5 8Zm3-6a6 6 0 0 1 4.914 9.444L11 8h1.8a4.8 4.8 0 0 0-8.124-3.463L4.078 3.46A5.976 5.976 0 0 1 8 2Z' fill='%23999'/%3E%3C/svg%3E") 0 0 / 100% no-repeat;
}
.home-questions-refresh:hover {
  color: #1E62EC;
}
.home-questions-refresh:hover::before {
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 8H3.2a4.8 4.8 0 0 0 8.124 3.463l.598 1.077a6 6 0 0 1-8.836-7.984L5 8Zm3-6a6 6 0 0 1 4.914 9.444L11 8h1.8a4.8 4.8 0 0 0-8.124-3.463L4.078 3.46A5.976 5.976 0 0 1 8 2Z' fill='%231E62EC'/%3E%3C/svg%3E");
}

.home-question-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.home-question-item {
  display: flex;
  flex-direction: column;
  padding: 4px 20px 4px 4px;
  min-height: 22px;
  line-height: 22px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  gap: 2px;
}
.home-question-item:hover {
  background-color: #F3F7FF;
}

.home-question-type {
  position: relative;
  display: flex;
  align-items: center;
  text-align: left;
}

.home-question-type span {
  font-family: "PingFang SC";
  font-weight: 550;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  color: #333;
  flex-shrink: 0;
}

.home-question-text {
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  font-size: 14px;
  color: #555;
}

.home-question-arrow {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  background: #CCC;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M6 4l4 4-4 4' fill='none' stroke='black' stroke-width='1.5'/%3E%3C/svg%3E") no-repeat center;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M6 4l4 4-4 4' fill='none' stroke='black' stroke-width='1.5'/%3E%3C/svg%3E") no-repeat center;
}
.home-question-item:hover .home-question-arrow {
  background: #1E62EC;
}

/* 底部角色 */
.home-character {
  position: absolute;
  right: -20px;
  top: 6px;
  width: 300px;
  height: 150px;
  z-index: 1;
}
.home-character-dec {
  position: absolute;
  top: 8px;
  right: 129px;
  width: 97px;
  height: 98px;
  z-index: 3;
  background: linear-gradient(135deg, rgba(58,120,246,0.1), rgba(40,211,253,0.1));
  border-radius: 50%;
}
.home-character-img {
  position: absolute;
  right: 30px;
  top: 0;
  width: 120px;
  height: 120px;
  object-fit: contain;
}
.home-character-overlay {
  position: absolute;
  right: 120px;
  top: 134px;
  width: 56px;
  height: 38px;
  background: #fff;
  z-index: 1;
}

/* ======= History View ======= */
.ai-drawer-history {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
}
.history-header {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 20px 20px 12px;
  flex-shrink: 0;
}
.history-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 16px;
  overscroll-behavior: contain;
}
.history-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  gap: 10px;
  text-align: left;
}
.history-item:hover {
  background: #F3F7FF;
}
.history-item-icon {
  font-size: 18px;
  color: #6B7B8D;
  flex-shrink: 0;
}
.history-item-title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.history-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #B0B6C0;
  font-size: 14px;
}

/* ======= Chat View ======= */
.ai-drawer-chat-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
}
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px 16px 0px 16px;
  overscroll-behavior: contain;
}
.chat-messages::-webkit-scrollbar {
  width: 0;
}
.chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #358BFC;
  font-size: 16px;
  text-align: center;
}
.chat-empty img {
  width: 80px;
  margin-bottom: 12px;
}
.chat-item {
  margin-bottom: 16px;
}
.msg-user, .msg-ai {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.msg-user {
  justify-content: flex-end;
}
.msg-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 5px;
  background: #fff;
  box-sizing: border-box;
  flex-shrink: 0;
}
.msg-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.msg-body {
  max-width: calc(100% - 50px);
}
.msg-bubble {
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
  text-align: justify;
}
.user-bubble {
  color: #333;
}
.ai-bubble {
  color: #333;
}
.think-bubble {
  font-size: 12px;
  color: #909399;
  padding-left: 8px;
  border-left: 2px solid #DCDFE6;
  margin-bottom: 6px;
}
.chat-toolbar {
  padding: 8px 16px;
  border-top: 1px solid rgba(0,0,0,0.04);
  text-align: left;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  flex-shrink: 0;
  background: #ffffff;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
.blinking-dots {
  animation: blink 2s infinite;
}

/* ======= Input ======= */
.ai-drawer-input {
  background: #fff;
  flex-shrink: 0;
  z-index: 10;
}

.ai-drawer-disclaimer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px 8px;
  gap: 12px;
}
.disclaimer-line {
  flex: 1;
  height: 1px;
  background: #E8EDF5;
}
.disclaimer-text {
  font-size: 12px;
  color: #B0B6C0;
  white-space: nowrap;
}

.input-box {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 125px;
  background: #fff;
  margin: 0 16px;
  padding: 12px 6px 12px 12px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.08);
}
.input-box:focus-within {
  border-color: #1E62EC;
}

.input-area-wrapper {
  position: relative;
  flex: 1;
  cursor: text;
}
.input-area {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  line-height: 22px;
  min-height: 22px;
  max-height: 180px;
  overflow: hidden auto;
  margin-bottom: 8px;
  word-break: break-word;
  text-align: left;
}
.input-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  color: #C0C4CC;
  font-size: 14px;
  pointer-events: none;
}

.input-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-counter {
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 12px;
  color: #CCC;
}
.input-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.send-btn.el-button--mini.is-circle {
  width: 28px;
  height: 28px;
  padding: 0;
}

/* ===== 智能体/课程选择弹层 ===== */
.attach-panel {
  position: absolute;
  left: 0;
  width: 320px;
  bottom: calc(100% + 8px);
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 30;
  overflow: hidden;
  max-height: 360px;
}

.panel-main {
  width: 140px;
  flex-shrink: 0;
  background: #1f2937;
  padding: 8px 0;
  box-sizing: border-box;
}

.panel-main-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s ease;
}

.panel-main-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.panel-main-item.active {
  background: #111827;
  color: #ffffff;
}

.panel-main-icon {
  font-size: 16px;
  margin-right: 8px;
  flex-shrink: 0;
}

.panel-main-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.panel-main-arrow {
  font-size: 12px;
  opacity: 0.6;
  flex-shrink: 0;
}

.panel-sub {
  flex: 1;
  min-width: 0;
  background: #ffffff;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.course-search {
  margin-bottom: 8px;
  flex-shrink: 0;
}

.course-search /deep/ .el-input__inner {
  background: #f5f7fa;
  border-color: #e4e7ed;
  color: #333;
  font-size: 12px;
}

.sub-list {
  flex: 1;
  overflow-y: auto;
  min-height: 60px;
}

.sub-list::-webkit-scrollbar {
  width: 4px;
}
.sub-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}

.sub-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  transition: background 0.15s ease;
}

.sub-item:hover {
  background: #f3f7ff;
}

.sub-item.active {
  background: #e6efff;
  color: #1e62ec;
}

.sub-item-icon {
  font-size: 14px;
  margin-right: 8px;
  flex-shrink: 0;
  color: #6b7b8d;
}

.sub-item-logo {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  object-fit: contain;
}

.sub-item.active .sub-item-icon {
  color: #1e62ec;
}

.sub-item-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sub-item-check {
  color: #1e62ec;
  font-size: 14px;
  flex-shrink: 0;
  margin-left: 6px;
}

.sub-empty {
  padding: 24px 0;
  text-align: center;
  color: #b0b6c0;
  font-size: 12px;
}

.course-pager {
  flex-shrink: 0;
  padding-top: 6px;
  text-align: right;
}

.course-pager /deep/ .el-pager li,
.course-pager /deep/ .btn-prev,
.course-pager /deep/ .btn-next {
  background: transparent;
  color: #606266;
}

.course-pager /deep/ .el-pager li.active {
  color: #1e62ec;
}

/* ===== @ 标签（底部输入框左下角） ===== */
.input-footer-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
}

.input-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.input-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 6px 3px 10px;
  background: #f3f7ff;
  border: 1px solid #1e62ec;
  border-radius: 12px;
  color: #1e62ec;
  font-size: 12px;
  line-height: 18px;
  user-select: none;
  cursor: default;
}

.input-tag-close {
  margin-left: 4px;
  font-size: 12px !important;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.input-tag-close:hover {
  opacity: 1;
}

/* ===== + 按钮（chat-toolbar 内） ===== */
.plus-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f3f7ff;
  color: #1e62ec;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.plus-btn:hover {
  background: #e6efff;
}

.plus-btn.active {
  background: #1e62ec;
  color: #ffffff;
  transform: rotate(45deg);
}
</style>
